<form [formGroup]="reportForm">
  <div class="general_main">
    <div class="row second_div">
      <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div class="text_header mt-5">
          <h3 class="h3-tipografia-govco">Reporte Ministerio SST</h3>
        </div>
      </div>
    </div>
    <div class="row ">
      <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div class="entradas-de-texto-govco">
          <label class="mx-auto text-center" for="id-tipo-persona">Reporte<span class="required">*</span></label>
          <select id="id-tipo-persona" class="form-control element mx-auto" formControlName="idTipoPersona"
            [ngClass]="{'error': isTouchedField(reportForm, 'idTipoPersona')}">
            <option value="" selected disabled>Seleccione</option>
            <option value="1">Persona Natural</option>
            <option value="2">Persona Jurídica</option>
          </select>
          <span *ngIf="!isValidField(reportForm, 'idTipoPersona')"
            class="error-texto-govco alert-entradas-de-texto-govco" id="tipoPersona-note" role="alert"
            aria-live="assertive">
            {{ getErrorMessage('idTipoPersona') }}
          </span>
        </div>
      </div>
      <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 justify-content-center text-center align-items-center">
        <div class="entradas-de-texto-govco">
          <label for="fecha-inicial">Fecha inicial <span class="required">*</span></label>
          <input class="element date_ini" type="date" id="fecha-inicial" formControlName="fechaInicial" (click)="verificarFecha()"
            [ngClass]="{'error': isTouchedField(reportForm, 'fechaInicial')}" />
          <span *ngIf="!isValidField(reportForm, 'fechaInicial')"
            class="error-texto-govco alert-entradas-de-texto-govco" id="fecha-inicial-note" role="alert"
            aria-live="assertive">
            {{ getErrorMessage('fechaInicial') }}
          </span>
        </div>
      </div>
      <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 justify-content-center text-center align-items-center">
        <div class="entradas-de-texto-govco">
          <label for="fecha-final">Fecha final <span class="required">*</span></label>
          <input class="element date_ini" type="date" id="fecha-final" formControlName="fechaFinal" (click)="verificarFecha()"
            [ngClass]="{'error': isTouchedField(reportForm, 'fechaFinal')}" />
          <span *ngIf="!isValidField(reportForm, 'fechaFinal')" class="error-texto-govco alert-entradas-de-texto-govco"
            id="fecha-final-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('fechaFinal') }}
          </span>
        </div>
      </div>
      <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 justify-content-center text-center align-items-center">
        <button class="btn btn-success" (click)="generarReporte()">Generar Reporte</button>
      </div>
    </div>
  </div>
</form>
